// extracted by mini-css-extract-plugin
export default {"reportUser":"eEwv_","modernReportUser":"_10Xrs"};